/**
 * Extract a column of data specified in encoding.
 */
export const Column = ({ value }) => {
    return () => value;
};
Column.props = {};
//# sourceMappingURL=column.js.map